import {adminAxios} from '@/Plugins/Axios';

/**
 * admin › ລາຍການ Order ພັດສະດຸ › ທຳລາຍພັດສະດຸ PDD — a Pinduoduo parcel returned to the Vientiane store is destroyed
 * ONLY on PDD's written instruction. The dispose records the instruction reference first, then runs the native
 * dispose as the admin; every other dispose path refuses a PDD bill until that reference is on file.
 * BFF: api/admin/pdd/waybills/* (SuperAdmin|service).
 */
const ROOT = 'pdd/waybills';

/**
 * Returned PDD parcels past the 30-day warehouse limit with no instruction yet, oldest first (≤ 200).
 * {available, rows} — available=false means the server is not migrated for this list yet (rows is then empty).
 */
export async function fetchAwaitingInstruction() {
    const res = await adminAxios.get(`${ROOT}/awaiting-instruction`);
    const body = (res && res.data) || {};
    return {
        available: body.available !== false,
        rows: Array.isArray(body.data) ? body.data : [],
    };
}

/** {waybill, disposed: true, instruction_ref, native}. Every refusal arrives as an error — read it with disposeFailure. */
export async function disposeWaybill(waybillCode, instructionRef, remark) {
    const body = {instruction_ref: instructionRef};
    if (remark) body.remark = remark;
    const res = await adminAxios.post(`${ROOT}/${encodeURIComponent(waybillCode)}/dispose`, body);
    return res.data;
}

/**
 * A failed dispose, sorted into what the page does about it:
 * - not_pdd_bill (404) · already_terminal (409, with the bill's current step)
 * - dispose_refused (422) — the native writer said no; the instruction STAYS on file, so a retry is allowed.
 *   The native writer answers {message: 'The given data was invalid.', errors: {field: [reason]}}, so the reason
 *   is its first field error, not its message.
 * - validation (422) — Laravel's {message, errors: {instruction_ref|remark: [...]}}
 * - other — network, 5xx, anything unexpected (message = the server's, when it sent one)
 */
export function disposeFailure(error) {
    const status = error && error.response ? error.response.status : 0;
    const data = (error && error.response && error.response.data) || {};

    if (status === 404 && data.error === 'not_pdd_bill') {
        return {kind: 'not_pdd_bill'};
    }
    if (status === 409 && data.error === 'already_terminal') {
        return {kind: 'already_terminal', step: data.step || ''};
    }
    if (status === 422 && data.error === 'dispose_refused') {
        const native = data.native || {};
        return {kind: 'dispose_refused', message: firstError(native.errors) || native.message || ''};
    }
    if (status === 422 && data.errors && (data.errors.instruction_ref || data.errors.remark)) {
        return {
            kind: 'validation',
            fields: {
                instruction_ref: data.errors.instruction_ref ? data.errors.instruction_ref[0] : '',
                remark: data.errors.remark ? data.errors.remark[0] : '',
            },
        };
    }
    return {kind: 'other', message: firstError(data.errors) || data.message || ''};
}

/** Laravel-style {field: [messages]} (or a bare string) → its first message. */
function firstError(errors) {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    const first = Object.values(errors).flat()[0];
    return typeof first === 'string' ? first : '';
}

/** The list endpoint's own error → its message. */
export function errorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    return (data && data.message) || fallback;
}
